module.exports = __webpack_public_path__ + "img/16d013-40.e217af33.png";